import script from "./AbstractsLBAOpen.vue?vue&type=script&setup=true&lang=js"
export * from "./AbstractsLBAOpen.vue?vue&type=script&setup=true&lang=js"

import "./AbstractsLBAOpen.vue?vue&type=style&index=0&id=f6f40246&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6f40246"]])

export default __exports__